import React, { useMemo } from "react"

import { css } from "@emotion/react"

import { Heading } from "../typography"

export interface CarouselSlideProps {
	imgSrc: string
	headline?: string
	backgroundPosition?: "top" | "bottom" | "right" | "center" | string
	onClick?: () => void
}

export const CarouselSlide: React.FC<CarouselSlideProps> = ({
	imgSrc,
	headline,
	backgroundPosition = "center",
	onClick,
}) => {
	const handleClick = () => {
		if (onClick) onClick()
	}

	const containerStyle = useMemo(() => {
		return css`
			cursor: ${onClick ? "pointer" : "auto"};
			pointer-events: ${onClick ? undefined : "none"};
			.slide-image {
				height: inherit;
				background-image: url("${imgSrc}");
				background-position: ${backgroundPosition};
				background-size: cover;
				background-repeat: no-repeat;
				transition: transform 300ms ease-out;
			}
			&:hover .slide-image {
				transform: ${onClick ? "scale(1.05)" : undefined};
			}
		`
	}, [onClick, backgroundPosition, imgSrc])

	return (
		<div
			role="button"
			tabIndex={0}
			css={containerStyle}
			onClick={handleClick}
			onKeyUp={(e) => {
				if (e.key === "Enter") {
					handleClick()
				}
			}}
		>
			<div className="slide-image" />
			{headline && (
				<div css={headlineContainerStyle}>
					<Heading css={headlineStyle} variant="h1-banner" textAlign="left">
						{headline}
					</Heading>
				</div>
			)}
		</div>
	)
}

const headlineContainerStyle = css`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 5rem;
	padding: 2rem;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));
`
const headlineStyle = css`
	color: white;
	text-shadow: 0 2px 10px rgba(0, 0, 0, 0.75);
`
